import {Injectable} from '@angular/core';
import {CanActivate, Route, Router, RouterStateSnapshot,} from '@angular/router';
import {AuthService} from "../services/auth.service";

@Injectable({
  providedIn: 'root',
})
export class NonAuthenticatedGuard implements CanActivate {

  constructor(public authService: AuthService, public router: Router) {
  }

  canActivate(
    route: Route,
    state: RouterStateSnapshot
  ): any {

    if (!this.authService.loggedIn()) return true;
    this.router.navigate(['/dashboard']).then();
    return false;
  }


}
